import axiosIns from '@/api/axios'

export const LOGOUT = (args) => {
    return axiosIns.post(`https://iam.ugems.id/realms/ugems/protocol/openid-connect/logout`, args, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}